module.exports = __webpack_public_path__ + "static/img/biankuang01.17b6bbd.png";


//////////////////
// WEBPACK FOOTER
// ./static/biankuang01.png
// module id = f0Ye
// module chunks = 1